<template lang="pug">
  .page__wr
    .about
      .about__modal(v-if="isShowModal" @click="toggleModal(indexImage)")
        //.about__modal-container
        img.about__modal-image(@click.stop :src="currentImage" alt="Слайд" loading="lazy")

      .about__wr
        .about__center
          .about__title-wr.title-oblique-line-anima
            h1.about__title.title-anima
              | {{h1}}
          .about__content(v-if="article")
            .about__content-desc
              | {{article.desc}}
            .about__content-slider
              .about__swiper-container.swiper-container(ref="swiperContainer")
                .swiper-wrapper
                  .swiper-slide(v-for="(slide, index) in article.slider" :key="index")
                    img.about__swiper-slide-image(@click="toggleModal(index)" :src="slide.image" :alt="slide.alt || 'Слайд'" loading="lazy")
                .swiper-button-prev(ref="swiperButtonPrev")
                .swiper-button-next(ref="swiperButtonNext")
      BottomNav(:links="links")
      Samedia
</template>

<script>
import EventBus from '@/eventBus';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import BottomNav from '@/components/common/bottomNav/bottomNav.vue';
import Samedia from '@/components/common/samedia/Samedia.vue';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';

export default {
  name: 'About',

  mixins: [AjaxHelpersVue, PopupHelpersVue],

  components: {SvgIcon, BottomNav, Samedia},

  data() {
    return {
      indexImage: 0,
      isShowModal: false,
      article: null,
      swiperInstance: null,
      sliderTestData: [
        {
          id: 1,
          image: "/img/about/slide-img.png",
          alt: "",
          title: "Эта красивая подпись под каждым изображением меняется и настраивается из админки"
        },
        {
          id: 2,
          image: "/img/about/slide-img.png",
          alt: "",
          title: "Эта красивая подпись под каждым изображением меняется и настраивается из админки"
        },
        {
          id: 3,
          image: "/img/about/slide-img.png",
          alt: "",
          title: "Эта красивая подпись под каждым изображением меняется и настраивается из админки"
        },
        {
          id: 4,
          image: "/img/about/slide-img.png",
          alt: "",
          title: "Эта красивая подпись под каждым изображением меняется и настраивается из админки"
        },
        {
          id: 5,
          image: "/img/about/slide-img.png",
          alt: "",
          title: "Эта красивая подпись под каждым изображением меняется и настраивается из админки"
        },
        {
          id: 6,
          image: "/img/about/slide-img.png",
          alt: "",
          title: "Эта красивая подпись под каждым изображением меняется и настраивается из админки"
        },
        {
          id: 7,
          image: "/img/about/slide-img.png",
          alt: "",
          title: "Эта красивая подпись под каждым изображением меняется и настраивается из админки"
        },
        {
          id: 8,
          image: "/img/about/slide-img.png",
          alt: "",
          title: "Эта красивая подпись под каждым изображением меняется и настраивается из админки"
        },
        {
          id: 9,
          image: "/img/about/slide-img.png",
          alt: "",
          title: "Эта красивая подпись под каждым изображением меняется и настраивается из админки"
        },
        {
          id: 10,
          image: "/img/about/slide-img.png",
          alt: "",
          title: "Эта красивая подпись под каждым изображением меняется и настраивается из админки"
        }
      ],
      links: {
        prev: {
          href: "/",
          txt: "Главная"
        },
        next: {
          href: "/sobytiya",
          txt: "События"
        }
      }
    }
  },

  created() {
    EventBus.$on('loadAboutPage', url => {
      this.request(url);
    });
  },

  computed: {
    currentImage() {
      return this.article.slider[this.indexImage].image
    }
  },

  methods: {
    request(url) {
      this.req('AboutPage:getAboutPage', {url}, res => {

        if (this.checkProperty(res.content.article)) {
          this.article = res.content.article;
          if (!res.content.article.slider) {
            this.article = {...this.article, slider: this.sliderTestData}
          }
          this.$nextTick(() => {
            this.initSlider();
          });
        }

        EventBus.$emit('pageDone');
      }, 'about');
    },

    initSlider() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }

      this.swiperInstance = new Swiper(this.$refs.swiperContainer, {
        slideToClickedSlide: true,
        initialSlide: 1,
        slidesPerView: 3,
        centeredSlides: true,
        spaceBetween: 0,
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
        observer: true,
        observeParents: true,
        breakpoints: {
          650: {
            slidesPerView: 1,
          },
          992: {slidesPerView: 3},
        }
      });
    },

    toggleModal(index) {
      this.indexImage = index;
      this.isShowModal = !this.isShowModal
    },
  }
}
</script>

<style>
.about {
  position: relative;
  height: 96%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}


.about__modal {
  background-color: white;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}


.about__modal-image {
  object-fit: cover;
  max-width: 80%;
  max-height: 90%;
}


.about__content-slider {
  width: calc(100vw - 32px);
  max-width: 454px;
  margin: 40px auto 0;
  height: 378px;
  display: flex;
}


@media (min-width: 650px) {
  .about__content-slider {
    max-width: 100%;
  }
}


.about__content-slider .swiper-wrapper {
  flex-direction: row;
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .about__content-slider {
    max-width: 90%;
  }
}


.about__content-slider .swiper-slide {
  display: grid;
  grid-template-rows: 1fr min-content;
}


.about__swiper-slide-image {
  cursor: pointer;
  transition: transform .3s linear, opacity .3s linear;
  margin: auto;
  width: 100%;
  max-width: 454px;
  max-height: 320px;
  object-fit: cover;
  opacity: .7;
}


.swiper-slide:not(.swiper-slide-active) .about__swiper-slide-image {
  transform: scale(0.82);
  pointer-events: none;
}


.swiper-slide-active .about__swiper-slide-image {
  opacity: 1;
}


.about__content-slider .swiper-button-prev {
  transition: background-color .2s linear;
  width: 40px;
  height: 40px;
  background-color: #FFFFFF;
  border-radius: 50%;
  left: 0;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2212%22%20height%3D%2225%22%20viewBox%3D%220%200%2012%2025%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M9.54801%206.73648L8.48701%205.67649L2.70801%2011.4535C2.61486%2011.5461%202.54093%2011.6561%202.49048%2011.7774C2.44003%2011.8986%202.41406%2012.0287%202.41406%2012.16C2.41406%2012.2913%202.44003%2012.4213%202.49048%2012.5426C2.54093%2012.6638%202.61486%2012.7739%202.70801%2012.8665L8.48701%2018.6465L9.54701%2017.5865L4.12301%2012.1615L9.54801%206.73648Z%22%20fill%3D%22black%22/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: 42% auto;
  background-position: 42% 60%;
}


.about__content-slider .swiper-button-next {
  transition: background-color .3s linear;
  width: 40px;
  height: 40px;
  background-color: #FFFFFF;
  border-radius: 50%;
  right: 0;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2212%22%20height%3D%2225%22%20viewBox%3D%220%200%2012%2025%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M2.45199%206.73648L3.51299%205.67649L9.29199%2011.4535C9.38514%2011.5461%209.45907%2011.6561%209.50952%2011.7774C9.55997%2011.8986%209.58594%2012.0287%209.58594%2012.16C9.58594%2012.2913%209.55997%2012.4213%209.50952%2012.5426C9.45907%2012.6638%209.38514%2012.7739%209.29199%2012.8665L3.51299%2018.6465L2.45299%2017.5865L7.87699%2012.1615L2.45199%206.73648Z%22%20fill%3D%22black%22/%3E%3C/svg%3E");
  background-size: 42% auto;
  background-position: 56% 60%;
}


.about__content-slider .swiper-button-prev:hover {
  background-color: rgba(98, 182, 242);
}


.about__content-slider .swiper-button-next:hover {
  background-color: rgba(98, 182, 242);
}


@media (min-width: 768px) {
  .about__content-slider .swiper-button-prev {
    left: 25%;
  }

  .about__content-slider .swiper-button-next {
    right: 25%;
  }
}


.about__title-wr {
  position: relative;
  display: inline-flex
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .about__title-wr:before {
    content: "";
    height: 1px;
    background: #686868;
    position: absolute;
    width: 80px;
    right: -80px;
    bottom: 25px;
    transform: rotate(-45deg)
  }
}


@media screen and (min-width: 1200px) and (min-height: 600px) and (min-width: 1600px) and (min-height: 930px) {
  .about__title-wr:before {
    width: 170px;
    right: -140px;
    bottom: 30px
  }
}


.about__title {
  letter-spacing: .18em;
  font-size: 2.375rem;
  text-transform: uppercase;
  padding: 0 35px;
  margin: 40px 0 20px;
  text-align: center;
  width: 100vw;

  box-sizing: border-box
}


@media screen and (min-width: 700px) {
  .about__title {
    text-align: left;
    width: auto;
    box-sizing: content-box
  }
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .about__title {
    font-size: 2.125rem;
    padding-left: 0;
    margin: 26px 0 0
  }
}


@media screen and (min-width: 1200px) and (min-height: 670px) {
  .about__title {
    font-size: 2.5rem
  }
}


@media screen and (min-width: 1600px) and (min-height: 930px) {
  .about__title {
    font-size: 3.75rem
  }
}


.about__center {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  align-items: flex-start;
  position: relative;
  margin-bottom: 32px;
}


.about__content {
  max-width: 100%;
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .about__content {
    box-sizing: border-box;
    padding-top: 24px;
  }
}


.about__content-desc {
  letter-spacing: .04em;
  font-size: .875rem;
  line-height: 1.2;
  padding: 0 35px;
  color: rgba(93, 93, 93, .8)
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .about__content-desc {
    width: 50%;
    margin: 0 auto;
    font-size: 1.0625rem;
    padding: 0
  }
}


@media screen and (min-width: 1600px) and (min-height: 930px) {
  .about__content-desc {
    font-size: 1.25rem;
    line-height: 1.4
  }
}

</style>